<spx-menu>
  <spx-menu-item [icon]="'home'" [translationKey]="'HOME.TITLE'" [route]="'home'"></spx-menu-item>
  <spx-menu-item [icon]="'inventory_2'" [translationKey]="'SAVED_CARTS.TITLE'" [route]="'savedcarts'"></spx-menu-item>
  <mat-divider></mat-divider>
  <spx-menu-item *ngIf="allowToSeeOrderHistory | async" [icon]="'update'" [translationKey]="'ORDERS.TITLE'" [route]="'orders'"></spx-menu-item>
  <spx-menu-item *ngIf="allowToSeeQuoteHistory | async" [icon]="'description'" [translationKey]="'QUOTES.TITLE'" [route]="'quotes'"></spx-menu-item>
  <mat-divider></mat-divider>
  <spx-menu-item [icon]="'phone'" [translationKey]="'CONTACT.TITLE'" [route]="'contact'"></spx-menu-item>
</spx-menu>
